import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import axios from "axios";

export default function Home() {
    const { t } = useTranslation();
    const [contacts, setContacts] = useState([]);
    // Fetch contacts from API
    useEffect(() => {
        axios
            .get("https://laravel-api.alburoujplast.com/api/contacts")
            .then((response) => {
                if (response.data.status === "success") {
                    setContacts(response.data.data);
                }
            })
            .catch((error) => {
                Swal.fire({
                    title: t("Error"),
                    text: t("Failed to fetch contacts"),
                    icon: "error",
                    confirmButtonColor: "#E56820",
                    customClass: {
                        popup: "rounded-2xl shadow-2xl bg-white",
                        title: "text-xl font-semibold text-[#E56820]",
                        confirmButton:
                            "px-6 py-2 rounded-full bg-[#E56820] hover:bg-[#E56820] transition-all duration-200",
                    },
                });
            });
    }, [t]);

    // Handle Show details with SweetAlert2
    const handleShow = (contact) => {
        Swal.fire({
            title: t(contact.name),
            html: `
                <div class="text-gray-600">
                    <p><strong>${t("Phone")}:</strong> ${contact.phone}</p>
                    <p><strong>${t("Email")}:</strong> ${contact.email}</p>
                    <p><strong>${t("Subject")}:</strong> ${contact.subject}</p>
                    <p><strong>${t("Message")}:</strong> ${contact.message}</p>
                </div>
            `,
            icon: "info",
            confirmButtonColor: "#E56820",
            confirmButtonText: t("Close"),
            customClass: {
                popup: "rounded-2xl shadow-2xl bg-white",
                title: "text-xl font-semibold text-[#E56820]",
                content: "text-gray-600",
                confirmButton:
                    "px-6 py-2 rounded-full bg-[#E56820] hover:bg-[#E56820] transition-all duration-200",
            },
        });
    };

    // Handle Delete with SweetAlert2 confirmation
    const handleDelete = (contactId) => {
        Swal.fire({
            title: t("Are you sure?"),
            text: t("You won't be able to revert this!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#E56820",
            cancelButtonColor: "#ef4444",
            confirmButtonText: t("Yes, delete it!"),
            cancelButtonText: t("Cancel"),
            customClass: {
                popup: "rounded-2xl shadow-2xl bg-white",
                title: "text-xl font-semibold text-[#E56820]",
                content: "text-gray-600",
                confirmButton:
                    "px-6 py-2 rounded-full bg-[#E56820] hover:bg-[#E56820] transition-all duration-200",
                cancelButton:
                    "px-6 py-2 rounded-full bg-red-500 hover:bg-red-600 transition-all duration-200",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                // Placeholder for delete API call
                axios
                    .delete(`https://laravel-api.alburoujplast.com/api/contacts/${contactId}`)
                    .then(() => {
                        setContacts(contacts.filter((contact) => contact.id !== contactId));
                        Swal.fire({
                            title: t("Deleted!"),
                            text: t("The contact has been deleted."),
                            icon: "success",
                            confirmButtonColor: "#E56820",
                            customClass: {
                                popup: "rounded-2xl shadow-2xl bg-white",
                                title: "text-xl font-semibold text-[#E56820]",
                                content: "text-gray-600",
                                confirmButton:
                                    "px-6 py-2 rounded-full bg-[#E56820] hover:bg-[#E56820] transition-all duration-200",
                            },
                        });
                    })
                    .catch(() => {
                        Swal.fire({
                            title: t("Error"),
                            text: t("Failed to delete contact"),
                            icon: "error",
                            confirmButtonColor: "#E56820",
                            customClass: {
                                popup: "rounded-2xl shadow-2xl bg-white",
                                title: "text-xl font-semibold text-[#E56820]",
                                confirmButton:
                                    "px-6 py-2 rounded-full bg-[#E56820] hover:bg-[#E56820] transition-all duration-200",
                            },
                        });
                    });
            }
        });
    };

    return (
        <>
            <section className="bg-white p-10 rounded-2xl shadow-2xl border border-gray-100">
                <div className="w-full bg-white rounded-2xl shadow-xl overflow-hidden">
                    <div className="grid grid-cols-5 gap-6 bg-gradient-to-r from-[#E56820] to-[#E56820] text-white font-semibold p-5">
                        <div className="text-center text-sm uppercase tracking-wider font-bold">
                            {t("Name")}
                        </div>
                        <div className="text-center text-sm uppercase tracking-wider font-bold">
                            {t("Phone")}
                        </div>
                        <div className="text-center text-sm uppercase tracking-wider font-bold">
                            {t("Email")}
                        </div>
                        <div className="text-center text-sm uppercase tracking-wider font-bold">
                            {t("Subject")}
                        </div>
                        <div className="text-center text-sm uppercase tracking-wider font-bold">
                            {t("Actions")}
                        </div>
                    </div>

                    {/* Table Body */}
                    <div className="divide-y divide-gray-100">
                        {contacts.map((contact, index) => (
                            <div
                                key={contact.id}
                                className="grid grid-cols-5 gap-6 p-5 bg-white hover:bg-[#E56820]/10 transform hover:-translate-y-0.5 transition-all duration-300 shadow-md"
                                style={{ animation: `fadeIn 0.5s ease-in ${index * 0.1}s both` }}
                            >
                                <div className="text-center text-gray-900 font-semibold">
                                    {contact.name}
                                </div>
                                <div className="text-center text-gray-700">{contact.phone}</div>
                                <div className="text-center text-gray-700">{contact.email}</div>
                                <div className="text-center text-gray-700">{contact.subject}</div>
                                <div className="text-center flex justify-center gap-4">
                                    <button
                                        onClick={() => handleShow(contact)}
                                        className="font-semibold"
                                    >
                                        <img
                                            className="w-[25px] h-[25px]"
                                            src={require("../../assets/icons/show.svg").default}
                                            alt="Show"
                                        />
                                    </button>
                                    <button
                                        onClick={() => handleDelete(contact.id)}
                                        className="font-semibold"
                                    >
                                        <img
                                            className="w-[25px] h-[25px]"
                                            src={require("../../assets/icons/delete.svg").default}
                                            alt="Delete"
                                        />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}